/**
 * @file Album folder related mutations.
 */

import gql from 'graphql-tag';

import {
  AlbumFolderAlbumChildren,
  AlbumFolderChildrenDetails,
  AlbumFolderDetails,
  AlbumFolderWatermarkConfig,
  AlbumFolderPhotosDetails,
  AlbumFolderForReviewDetails,
  AlbumFolderMainCoverPhoto,
  AlbumFolderCreatorAccessDetails,
  AlbumFolderShutterbugDetails,
  AlbumFolderPricingDetails,
  AlbumFolderPendingCustomPrintDetails,
  AlbumFolderEventSettingsFields,
  AlbumFolderTaxDetails,
  AlbumFolderDiscountTemplateDetails,
  AlbumFolderHierarchyGradeDetails,
  AlbumFolderYearbookSettings,
  AlbumFolderHierarchyShippingSettings,
} from '../fragments/album-folder';

export const albumFolderCreate = gql`
  mutation albumFolderCreate($input: AlbumFolderCreateInput!) {
    albumFolderCreate(input: $input) {
      album_folder {
        ...AlbumFolderDetails
        ...AlbumFolderChildrenDetails
        ...AlbumFolderWatermarkConfig
        ...AlbumFolderPhotosDetails
        ...AlbumFolderForReviewDetails
        ...AlbumFolderMainCoverPhoto
        ...AlbumFolderCreatorAccessDetails
        ...AlbumFolderShutterbugDetails
        ...AlbumFolderPendingCustomPrintDetails
        event_settings {
          ...AlbumFolderEventSettingsFields
        }
        has_album
        has_children
        creator: account {
          id
        }
        tags {
          total
        }
      }
    }
  }
  ${AlbumFolderDetails}
  ${AlbumFolderChildrenDetails}
  ${AlbumFolderWatermarkConfig}
  ${AlbumFolderPhotosDetails}
  ${AlbumFolderForReviewDetails}
  ${AlbumFolderMainCoverPhoto}
  ${AlbumFolderCreatorAccessDetails}
  ${AlbumFolderShutterbugDetails}
  ${AlbumFolderPendingCustomPrintDetails}
  ${AlbumFolderEventSettingsFields}
`;

export const albumFolderDelete = gql`
  mutation albumFolderDelete($input: AlbumFolderDeleteInput!) {
    albumFolderDelete(input: $input) {
      success
    }
  }
`;

export const albumFolderUpdate = gql`
  mutation albumFolderUpdate($input: AlbumFolderUpdateInput!) {
    albumFolderUpdate(input: $input) {
      album_folder {
        ...AlbumFolderDetails
        ...AlbumFolderWatermarkConfig
        ...AlbumFolderPricingDetails
        ...AlbumFolderTaxDetails
        ...AlbumFolderDiscountTemplateDetails
        ...AlbumFolderHierarchyGradeDetails
        ...AlbumFolderYearbookSettings
        ...AlbumFolderHierarchyShippingSettings
        event_settings {
          ...AlbumFolderEventSettingsFields
        }
      }
    }
  }
  ${AlbumFolderDetails}
  ${AlbumFolderWatermarkConfig}
  ${AlbumFolderPricingDetails}
  ${AlbumFolderTaxDetails}
  ${AlbumFolderEventSettingsFields}
  ${AlbumFolderDiscountTemplateDetails}
  ${AlbumFolderHierarchyGradeDetails}
  ${AlbumFolderYearbookSettings}
  ${AlbumFolderHierarchyShippingSettings}
`;

export const albumFoldersUpdate = gql`
  mutation albumFoldersUpdate($input: AlbumFoldersUpdateInput!) {
    albumFoldersUpdate(input: $input) {
      album_folders {
        id
        display_order
      }
    }
  }
`;

export const albumFolderAddAlbums = gql`
  mutation albumFolderAddAlbums($input: AlbumFolderAddAlbumsInput!) {
    albumFolderAddAlbums(input: $input) {
      album_folder {
        ...AlbumFolderAlbumChildren
      }
    }
  }
  ${AlbumFolderAlbumChildren}
`;

export const albumFolderRemoveAlbums = gql`
  mutation albumFolderRemoveAlbums($input: AlbumFolderRemoveAlbumsInput!) {
    albumFolderRemoveAlbums(input: $input) {
      album_folder {
        ...AlbumFolderAlbumChildren
      }
    }
  }
  ${AlbumFolderAlbumChildren}
`;

export const albumFolderAddPhotos = gql`
  mutation albumFolderAddPhotos($input: AlbumFolderAddPhotosInput!) {
    albumFolderAddPhotos(input: $input) {
      album_folder_photos {
        id
        status
      }
    }
  }
`;

export const albumFolderDeletePhotos = gql`
  mutation albumFolderPhotosDelete($input: AlbumFolderPhotosDeleteInput!) {
    albumFolderPhotosDelete(input: $input) {
      album_folder_photos {
        id
        status
      }
    }
  }
`;

export const albumFolderAssignPhotos = gql`
  mutation albumFolderAssignPhotos($input: AlbumFolderPhotosAssignInput!) {
    albumFolderPhotosAssign(input: $input) {
      album_folder_photos {
        id
        status
      }
    }
  }
`;

export const albumFolderJoin = gql`
  mutation albumFolderJoin($input: AlbumFolderJoinInput!) {
    albumFolderJoin(input: $input) {
      success
    }
  }
`;

export const albumFolderAlbumPhotosReview = gql`
  mutation albumFolderAlbumPhotosReview(
    $input: AlbumFolderAlbumPhotosReviewInput!
  ) {
    albumFolderAlbumPhotosReview(input: $input) {
      success
    }
  }
`;

export const albumFolderUnjoin = gql`
  mutation albumFolderUnjoin($input: AlbumFolderUnjoinInput!) {
    albumFolderUnjoin(input: $input) {
      success
    }
  }
`;

export const hierarchyMemberUnjoin = gql`
  mutation hierarchyMemberUnjoin($input: HierarchyMemberUnjoinInput!) {
    hierarchyMemberUnjoin(input: $input) {
      success
    }
  }
`;
